import { gql } from '@apollo/client';

export const ADD_INSTITUTIONS_TO_INTERVENTION = gql`
  mutation addInstitutionsToIntervention($input: AddInstitutionsToInterventionInput!) {
    intervention: addInstitutionsToIntervention(input: $input) {
      id
    }
  }
`;
